import React from 'react'
import { Link } from 'react-router-dom'
import location1 from '../../assets/images/background/location-1.jpg'
import location2 from '../../assets/images/background/location-2.jpg'
import location3 from '../../assets/images/background/location-3.jpg'



const locations = () => {
    return (
        <>
            <div className="location-section">
                <div className="container">
                    <div className="row gutter-y-30">
                        <div
                            className="col-lg-4 col-md-6 animate fadeInRight wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="200ms"
                        >
                            <div
                                className="contact-box"
                                style={{
                                    backgroundImage: `url(${location1})`,
                                  }}
                            >
                                <div className="contact-details">
                                    <h4>Washington, D.C.</h4>
                                    <p>2220 Plymouth Rd #302 Hopkins, Minnesota(MN), 55305</p>
                                    <Link to="telto:+ 123 4567 89 000">+ 123 4567 89 000</Link>
                                    <Link to="mailto:uniqoconsulting@gmail.com">
                                        uniqoconsulting@gmail.com
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div
                            className="col-lg-4 col-md-6  animate fadeInRight wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="400ms"
                        >
                            <div
                                className="contact-box"
                                style={{
                                    backgroundImage: `url(${location2})`,
                                  }}
                            >
                                <div className="contact-details">
                                    <h4>Los Angeles City</h4>
                                    <p>2220 Plymouth Rd #302 Hopkins, Minnesota(MN), 55305</p>
                                    <Link to="telto:+ 123 4567 89 000">+ 123 4567 89 000</Link>
                                    <Link to="mailto:uniqoconsulting@gmail.com">
                                        uniqoconsulting@gmail.com
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div
                            className="col-lg-4 col-md-6  animate fadeInRight wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="600ms"
                        >
                            <div
                                className="contact-box"
                                style={{
                                    backgroundImage: `url(${location3})`,
                                  }}
                            >
                                <div className="contact-details">
                                    <h4>New York City</h4>
                                    <p>2220 Plymouth Rd #302 Hopkins, Minnesota(MN), 55305</p>
                                    <Link to="telto:+ 123 4567 89 000">+ 123 4567 89 000</Link>
                                    <Link to="mailto:uniqoconsulting@gmail.com">
                                        uniqoconsulting@gmail.com
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default locations
